import React, { useEffect, useRef, useState } from "react";
import Records from "./Records";
import ReactPaginate from "react-paginate";
import "./Route.css";
import { CSVLink } from "react-csv";
import { useLocation, useHistory } from "react-router-dom";
import AddRoute from "./AddRoute/RouteInfo";
import useHttp from "../../Hooks/use-http";
import Message from "../../Modal/Message";
import loadingGif from "../../Assets/loading-gif.gif";
import { Autocomplete, TextField, Box, Paper, Button as MuiButton } from "@mui/material";
import Button from "../CommonComponent/Button";
import CorporateFilter from "../CommonComponent/CorporateFilter";
import HeaderFilter from "../CommonComponent/HeaderFilter";
import TestRouteInfo from "./TestAddRoute/TestRouteInfo";
import CommonTablePagination from "../CommonComponent/CommonTablePagination";
import { PAGINATIONBASEVALUE } from "../../Constant";
import PortalTitle from "../CommonComponent/PortalTitle";
// import TestRouteInfo from "./TestAddRoute/TestRouteInfo";

let myClick = false;
let prev_id = "1";
let routeListFlag = 0;
let route_details = [];

function Routes() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATIONBASEVALUE);
  const [filteredData, setFilteredData] = useState([]);
  const searchInputRef = useRef();
  const [isAddRouteClicked, setIsAddRouteClicked] = useState();
  const [isNewUIRouteClicked, setIsNewUIRouteClicked] = useState();
  const [isRouteCreated, setIsRouteCreated] = useState();
  const [roleId, setRoleId] = useState(localStorage.getItem("roleId"));
  const [selectedCorporate, setSelectedCorporate] = useState(null);
  const [corporatesData, setCorporatesData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const history = useHistory();
  const [toggleChangeAPICall, setToggleChangeAPICall] = useState(false);

  const routeCreationStatus = (data) => {
    setIsRouteCreated(data);
  };

  const { isLoading, sendRequest } = useHttp();

  useEffect(() => {
    const handleStorageChange = () => {
      setRoleId(localStorage.getItem("roleId"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const TRIP_TITLE = [
    "Route ID",
    "Route Name",
    roleId === "1" ? "Corporate Name" : null,
    "Timing",
    "Stops",
    // "City",
    // "Country",
    "Route Type",
  ].filter(Boolean);

  const search = useLocation().search;
  const id = new URLSearchParams(search).get("departmentId");

  const authenticateUser = (data) => {
    let route_list = [];
    let timings = {};
    // if (data.RouteList) {
    if (data.shuttleRoutes) {
      for (let i = 0; i < data?.shuttleRoutes?.length; i++) {
        route_list.push({
          id: i + 1,
          route_id: data?.shuttleRoutes[i]?.RouteID,
          route: data?.shuttleRoutes[i]?.RouteName,
          city: data?.shuttleRoutes[i]?.City,
          country: data?.shuttleRoutes[i]?.Country,
          zone_price: data?.shuttleRoutes[i]?.ZonePrice,
          route_type: data?.shuttleRoutes[i]?.RouteTypeName,
          corporateName: data?.shuttleRoutes[i]?.CorporateName,
          timing: data?.shuttleRoutes[i]?.RouteTimes,
          stops: data?.shuttleRoutes[i]?.Stops,
          isDeactivated: data?.shuttleRoutes[i]?.IsDeactivated,
          corporateId: data?.shuttleRoutes[i]?.CorporateID,
        });
      }
    }
    route_details = route_list;
    setFilteredData(route_list);
  };
  useEffect(() => {
    sendRequest(
      {
        // url: "/api/v1/Route/GetRoutList",
        url: "/shuttleroutes",

        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: localStorage.getItem("user"),
          // corporateID: selectedCorporate ? selectedCorporate[0]?.cpId : "",
          data: {
            filter: {
              corporateID: selectedCorporate
                ? selectedCorporate[0]?.cpId
                : localStorage.getItem("corpId")
                ? localStorage.getItem("corpId")
                : "",
            },
          },
          // corporateID:
          //   localStorage.getItem("roleId") == 1
          //     ? ""
          //     : localStorage.getItem("corpId"),

          // departmentID: "",
        },
      },
      authenticateUser
    );
  }, [sendRequest, toggleChangeAPICall]);
  // const indexOfLastRecord = currentPage * recordsPerPage;
  // const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  // const currentRecords = filteredData?.slice(
  //   indexOfFirstRecord,
  //   indexOfLastRecord

  // );

  // const nPages = Math.ceil(filteredData?.length / recordsPerPage);

  // let fromRecords =
  //   currentPage === 1 ? 1 : (currentPage - 1) * recordsPerPage + 1;
  // let toRecords = Math.min(currentPage * recordsPerPage, filteredData?.length);
  // if (toRecords === 0) fromRecords = 0;

  const nPages = Math.ceil(filteredData.length / rowsPerPage);

  let fromRecords = 0;
  // if (currentPage === 1) fromRecords = 1;
  if (page === 0) fromRecords = 1;
  // else fromRecords = (currentPage - 1) * rowsPerPage;
  else fromRecords = page * rowsPerPage;

  let toRecords = 0;
  if (
    (myClick
      ? page * rowsPerPage - (filteredData.length % rowsPerPage)
      : page * rowsPerPage +
        rowsPerPage -
        (filteredData.length % rowsPerPage)) > filteredData.length
  )
    toRecords = filteredData.length;
  else toRecords = page * rowsPerPage;
  if (toRecords === 0) fromRecords = 0;
  if (page === nPages) toRecords = filteredData.length;
  // Calculate pagination
  const indexOfLastRecord = page * rowsPerPage + rowsPerPage;
  const indexOfFirstRecord = page * rowsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const addRouteClickHandler = () => {
    setIsAddRouteClicked(true);
  };

  // for testing
  const newUIRouteClickHandler = () => {
    setIsNewUIRouteClicked(true);
  };

  const routeSearchHandler = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setFilteredData(
      route_details.filter(
        (data) =>
          data.route?.toLowerCase().includes(searchValue) ||
          data.route_id?.toLowerCase().includes(searchValue) ||
          data.city?.toLowerCase().includes(searchValue) ||
          data.country?.toLowerCase().includes(searchValue) ||
          data.zone_price?.toString()?.toLowerCase().includes(searchValue) ||
          data.route_type?.toLowerCase().includes(searchValue)
      )
    );
  };

  return (
    <React.Fragment>
      {isAddRouteClicked && <div className="add-route-fullcontainer"></div>}
      {/* {isNewUIRouteClicked && <div className="add-route-fullcontainer"></div>} */}

      <div className="trips-details" id="trip-table">
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="table-container-routes">
            <Paper
              sx={{
                width: "100%",
                mb: 2,
                borderRadius: "10px",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                border: "none",
                borderBottom: "none",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 2,
                  pt: 1,
                  pb: 1,
                  borderRadius: "10px",
                  flexDirection: { xs: "column", md: "row" },
                  gap: { xs: 1, md: 0 },
                }}
              >
                <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center" }}>
                  <PortalTitle fallback="Shuttle Routes" />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
                  }}
                >
            {localStorage.getItem("roleId") == "1" && (
                <CorporateFilter
                  selectedCorporate={selectedCorporate}
                  setSelectedCorporate={setSelectedCorporate}
                  mainData={route_details}
                  filteredData={filteredData}
                  setFilteredData={setFilteredData}
                  setIsRefereshData={setToggleChangeAPICall}
                  corporateData={corporatesData}
                  setCorporateData={setCorporatesData}
                />
            )}
            <TextField
              type="text"
              ref={searchInputRef}
              onChange={routeSearchHandler}
              placeholder="Search"
              label="Search"
              className="route-search-input"
              size="small"
              variant="standard"
            />
              <CSVLink
                data={route_details}
                filename={"data.csv"}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <MuiButton
                      variant="outlined"
                      sx={{
                        color: "#1D85C6",
                        border: "1px solid #1D85C6",
                        ":hover": {
                          border: "1px solid #1D85C6",
                          color: "black",
                        },
                      }}
                      size="small"
              >
                Export
                    </MuiButton>
              </CSVLink>
                  {localStorage.getItem("userType") !== "AccountManager" && (
                    <Button
                      label="Add Route"
                      onClick={() => history.push("/addroute")}
                      variant="contained"
                      size="medium"
                      sx={{
                        backgroundColor: "#44B150",
                        ":hover": {
                          backgroundColor: "#44B150",
                          opacity: 0.8,
                        },
                        boxShadow: "none",
                        fontFamily: "Montserrat",
                        fontSize: "12px",
                        padding: "8px 20px",
                        textTransform: "none",
                        minWidth: "110px",
                        marginLeft: "12px",
                      }}
                    />
                  )}
                </Box>
              </Box>
          <Records
            data={currentRecords}
            headers={TRIP_TITLE}
            isLoading={isLoading}
            setToggleChangeAPICall={setToggleChangeAPICall}
          />
              <Box
                sx={{
                  position: "sticky",
                  bottom: 0,
                  background: "white",
                  zIndex: 1,
                  border: "none !important",
                  borderTop: "none !important",
                  borderBottom: "none !important",
                  "&::before": {
                    display: "none",
                  },
                  "&::after": {
                    display: "none",
                  },
                }}
              >
            <CommonTablePagination
              page={page}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setPage={setPage}
              filteredData={filteredData}
                  styling={{
                    display: "flex",
                    justifyContent: "flex-end",
                    border: "none",
                    borderTop: "none",
                    borderBottom: "none",
                    "& .MuiTablePagination-root": {
                      border: "none",
                      borderTop: "none",
                      borderBottom: "none",
                      "&::before": {
                        display: "none",
                      },
                      "&::after": {
                        display: "none",
                      },
                    },
                    "& .MuiTablePagination-toolbar": {
                      border: "none",
                      borderTop: "none",
                      borderBottom: "none",
                      "&::before": {
                        display: "none",
                      },
                      "&::after": {
                        display: "none",
                      },
                    },
                    "& .MuiTablePagination-spacer": {
                      border: "none",
                    },
                  }}
            />
              </Box>
            </Paper>
          </div>
        </Box>
        {isAddRouteClicked && (
          <AddRoute
            routeCreationStatus={routeCreationStatus}
            setIsAddRouteClicked={setIsAddRouteClicked}
          />
        )}

        {/*for testing  */}
        {isNewUIRouteClicked && (
          <TestRouteInfo
            routeCreationStatus={routeCreationStatus}
            setIsNewUIRouteClicked={setIsNewUIRouteClicked}
          />
        )}

        {isRouteCreated &&
          (isRouteCreated === "Loading" ? (
            <img
              src={loadingGif}
              style={{ position: "absolute", top: "40%", left: "57%" }}
              alt="loading-gif"
            />
          ) : (
            <Message
              message={isRouteCreated}
              setIsRouteCreated={setIsRouteCreated}
              type={isRouteCreated === "Success" ? "success" : "error"}
            />
          ))}
      </div>
    </React.Fragment>
  );
}

export default Routes;
